<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/qa' }">问题答疑</el-breadcrumb-item>
            <el-breadcrumb-item>创建问题答疑</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="120px">
            <el-form-item label="名称">
                <el-input v-model="form.title" maxlength="150" show-word-limit/>
            </el-form-item>
            <el-form-item label="详情图">
              <el-upload
                  v-model:file-list="form.detail"
                  action=""
                  :http-request="uploadDetailImg"
                  list-type="picture-card"
                  :on-preview="handleDetailPictureCardPreview"
                  :on-remove="handleDetailRemove"
              >
                  <el-icon><Plus /></el-icon>
                  <template #tip>
                      <div class="el-upload__tip">
                        请上传jpg/png的统一尺寸图片，图片大小不能大于10M
                      </div>
                    </template>
              </el-upload>
  
              <el-dialog v-model="dialogDetailVisible">
                  <img w-full :src="dialogDetailImageUrl" alt="Preview Image" />
              </el-dialog>
          </el-form-item>
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">下架</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">返回</el-button>
            </el-form-item>
        </el-form>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted, ref } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'

  const router = useRouter()
  const route = useRoute()
  const dialogDetailImageUrl = ref('')
  const dialogDetailVisible = ref(false)
  const baseData:any = reactive({
    loading: false,
  })
  const ueConfig = reactive({
      UEDITOR_HOME_URL: '/manager/static/UEditor/',
      UEDITOR_CORS_URL: '/manager/static/UEditor/',
      initialFrameWidth: '100%',
      initialFrameHeight: 400,
      autoHeightEnabled: false,
      autoFloatEnabled: false,
      enableAutoSave: false,
      serverUrl: '/api/ueditor/config',
      toolbars: [
          ['fullscreen', 'source', '|', 'undo', 'redo', '|']
      ]
  })
  const form = reactive({
    id: '',
    title:'',
    detail: [],
    status: '1',
  })
  const uploadDetailImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过10MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data:any = {name:file.name,url:res.data.img}
        form.detail.pop()
        form.detail.push(data);
        }
    })
  }
  const get = () => {
    const loading = ElLoading.service({lock: true})
    api.qaApi.get({id:route.params.id}).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
            form.id = res.data.id
            form.detail = res.data.detail ? res.data.detail : []
            form.title = res.data.title
            form.status = res.data.status.toString()
        }else{
            ElMessage.error(res.message)
        }
        loading.close()
    })
  }
  const onSubmit = () => {
    const loading = ElLoading.service({lock: true})
    var data:any = {
      id: form.id,
      detail: form.detail ? JSON.stringify(form.detail) : "",
      title: form.title,
      status: form.status
    }
    api.qaApi.edit(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/qa");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const handleDetailPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogDetailImageUrl.value = uploadFile.url!
    dialogDetailVisible.value = true
  }
  const handleDetailRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }
  const goBack = () => {
    router.go(-1);
  }
  onMounted(() => {
    form.id = route.params.id
    get()
  })
  </script>